import onlineUsers from './onlineUsers.js';
let cookieKey = 'pg-054-LAST-827-USER';
let callbackInfo = {
    ret: false,
    message: ''
};
let mustVerifyLoginProcessResultList = [];
let mustVerifyLoginProcessResultNum = 0;
let verifyOneLoginProcessResultNum = 0;
let verifyOneLoginProcessResultList = [];
let mustVerifyLoginProcessList = [];
let verifyOneLoginProcessList = [];
let routeName = '';
export default {
    /* 登录完成后初始化数据 */
    initData(name) {
        routeName = name;
        window.vue.$api.listInitMenuInfo(
            {
                token: sessionStorage.getItem('token'),
                sPlatformFlg: window.app.sPlatformFlg
            },
            response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    window.vue.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    window.vue.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    return;
                }
                let initMenuData = response.data.content;
                sessionStorage.setItem('menuData', JSON.stringify(initMenuData));
                /* 初始化权限 */
                this.initPermissionInfo(initMenuData);
            }
        );
    },
    /* 初始化权限数据 */
    initPermissionInfo(initMenuData) {
        window.vue.$api.initPermissionInfo(null, response => {
            if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('error.ERROR_PERMISSION_INFO'),
                    type: 'error'
                });
                return;
            }
            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('javaCommon.' + response.data.statusCode),
                    type: 'error'
                });
                return;
            }
            sessionStorage.setItem('stringPermissions', response.data.content.stringPermissions);
            sessionStorage.setItem('roles', response.data.content.roles);
            this.initRouters(initMenuData);
        });
    },
    initRouters(initMenuData) {
        window.vue.$router.options.routes.map(x => {
            if (x.name === routeName) {
                x.children = [];
                window.vue.$util.addRouter(initMenuData, x.children);
                for (let i = 0; i < window.app.modRouter.length; i++) {
                    if (window.app.modRouter[i]) {
                        window.app.modRouter[i].mergeRoutes(initMenuData, x.children);
                    }
                }
                window.vue.$router.addRoutes(window.vue.$router.options.routes);
            }
        });
        let param = {
            initMenuData: initMenuData
        };
        window.vue.$router.push({ name: routeName, params: { param } });
        // 启动在线用户状态心跳
        //onlineUsers.endMQSend();
        //onlineUsers.beginMQSend();
    },
    getCookieLoginInfo(login) {
        let rememberPw = false;
        let cookieValue = this.getCookie(cookieKey);
        if (cookieValue == null || cookieValue == '') {
            return false;
        }
        try {
            let value = cookieValue.split(',');
            if (value.length < 2) {
                return false;
            }
            let username = value[0];
            let state = value[1];
            if (state == 1) {
                //选中
                rememberPw = true;
            }

            if (value.length >= 3) {
                let password = value[2];
                if (password != null) {
                    login.password = password;
                }
            }
            if (username != null) {
                login.username = username;
            }
            value = null;
            return rememberPw;
        } catch (e) {
            cookieValue = null;
            window.vue.$log.error('login', e);
        }
        cookieValue = null;
        return rememberPw;
    },
    getCookie(name) {
        let arg = name + '=';
        let alen = arg.length;
        let cookieObj = document.cookie;
        let clen = cookieObj.length;
        let i = 0;
        while (i < clen) {
            let j = i + alen;
            let cookieOffset = this.getCookieVal(j);
            if (cookieObj.substring(i, j) == arg) {
                cookieOffset = this.getCookieVal(j);
                return cookieOffset;
            }
            i = cookieObj.indexOf(' ', i) + 1;
            if (i == 0) break;
        }
        name = null;
        clen = null;
        return null;
    },
    getCookieVal(offset) {
        let endstr = document.cookie.indexOf(';', offset);
        if (endstr == -1) endstr = document.cookie.length;
        let cookieVal = unescape(document.cookie.substring(offset, endstr));
        return cookieVal;
    },
    /* 用户记录密码功能实现 */
    dealUserInfo(login, rememberPw) {
        var clearDate = new Date();
        clearDate.setTime(clearDate.getTime() + 7 * (24 * 3600 * 1000));
        var value = login.username;
        //是否记住密码
        var state;
        if (rememberPw) {
            //判断记住密码是否选中
            state = 1;
            value = login.username + ',' + state + ',' + login.password;
        } else {
            state = 0;
            value = login.username + ',' + state;
        }
        //设置Cookie的值
        document.cookie = cookieKey + '=' + escape(value) + (clearDate == null ? '' : '; expires=' + clearDate.toGMTString());
    },

    /* 登录程序处理方法 */
    startLogin(login, callback) {
        window.vue.$api.getSystemInfo({}, response => {
            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('javaCommon.' + response.data.statusCode),
                    type: 'error'
                });
                window.vue.$log.error('menuManagement/deleteMenuInfo', response.data.statusMessage);
                callbackInfo.ret = false;
                return callback(callbackInfo);
            }
            sessionStorage.setItem('systemId', response.data.content.systemId);
            this.getLoginProcessMethod(login, callback);
        });
    },
    getLoginProcessMethod(login, callback) {
        let sysId = sessionStorage.getItem('systemId');
        window.vue.$api.getLoginProcessMethod({ sysId: sysId }, response => {
            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('javaCommon.' + response.data.statusCode),
                    type: 'error'
                });
                window.vue.$log.error('menuManagement/deleteMenuInfo', response.data.statusMessage);
                callbackInfo.ret = false;
                return callback(callbackInfo);
            }
            if (null == response.data.content || (response.data.content.mustVerifyLoginProcessList.length == 0 && response.data.content.verifyOneLoginProcessList.length == 0)) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('message.NOT_DETECTED_LOGIN_PROCESS'),
                    type: 'error'
                });
                callbackInfo.ret = false;
                return callback(callbackInfo);
            }
            this.getLoginProcessResult(response.data.content, login, callback);
        });
    },
    getLoginProcessResult(loginProcess, login, callback) {
        mustVerifyLoginProcessResultList = [];
        verifyOneLoginProcessResultList = [];
        let params = {
            username: login.username,
            password: login.password,
            currentToken: login.currentToken,
            sysId: sessionStorage.getItem('systemId')
        };
        mustVerifyLoginProcessList = loginProcess.mustVerifyLoginProcessList;
        mustVerifyLoginProcessResultNum = mustVerifyLoginProcessList.length;
        verifyOneLoginProcessList = loginProcess.verifyOneLoginProcessList;
        verifyOneLoginProcessResultNum = verifyOneLoginProcessList.length;
        params.isMustVerify = true;
        for (const loginProcess of mustVerifyLoginProcessList) {
            let loginMethod = window.validateLogon.loginMethod.get(loginProcess.sCheckType);
            let _this = this;
            loginMethod[loginProcess.sUrl](params, function(val) {
                let result = window.vue.$util.clone(val);
                mustVerifyLoginProcessResultList.push(result);
                if (mustVerifyLoginProcessResultList.length == mustVerifyLoginProcessList.length) {
                    _this.dealResult(callback);
                }
            });
        }
        for (const loginProcess of verifyOneLoginProcessList) {
            let _this = this;
            let loginMethod = window.validateLogon.loginMethod.get(loginProcess.sCheckType);
            loginMethod[loginProcess.sUrl](params, function(val) {
                let result = window.vue.$util.clone(val);
                verifyOneLoginProcessResultList.push(result);
                if (verifyOneLoginProcessResultList.length == verifyOneLoginProcessList.length) {
                    _this.dealResult(callback);
                }
            });
        }
    },
    dealResult(callback) {
        let checkuserProcessList = [];
        if (mustVerifyLoginProcessResultList.length == mustVerifyLoginProcessResultNum && verifyOneLoginProcessResultList.length == verifyOneLoginProcessResultNum) {
            for (let index = 0; index < mustVerifyLoginProcessResultList.length; index++) {
                const result = mustVerifyLoginProcessResultList[index];
                if (window.vue.$util.isEmpty(result) || window.vue.$util.isEmpty(result.ret) || !result.ret) {
                    window.vue.$message({
                        showClose: true,
                        message: result.message,
                        type: 'error'
                    });
                    callbackInfo.ret = false;
                    return callback(callbackInfo);
                }
            }
            checkuserProcessList = [...mustVerifyLoginProcessResultList];
            if (verifyOneLoginProcessResultNum == 0) {
                return this.UserConsistencyCheck(checkuserProcessList, callback);
            }
            let result = false;
            let resultMessage = '';
            for (const process of verifyOneLoginProcessResultList) {
                if (process) {
                    result = true;
                    checkuserProcessList.push(process);
                } else {
                    resultMessage += process.type + '、';
                }
            }
            if (result) {
                this.UserConsistencyCheck(checkuserProcessList, callback);
            } else {
                window.vue.$message({
                    showClose: true,
                    message: resultMessage + ':' + '全部校验失败',
                    type: 'error'
                });
                callbackInfo.ret = false;
                return callback(callbackInfo);
            }
        }
    },
    /* 登陆成功的用户信息校验 */
    UserConsistencyCheck(loginProcessResult, callback) {
        if (loginProcessResult.length == 1 && loginProcessResult[0].userIds.length == 1) {
            let loginInfo = {
                userId: loginProcessResult[0].userIds[0]
            };
            this.callbackLoginInfo(loginInfo);
            callbackInfo.ret = true;
            return callback(callbackInfo);
        }
        let verifySuccessUserIds = [];
        let process = loginProcessResult[0];
        loginProcessResult.splice(0, 1);
        process.userIds.forEach(userId => {
            loginProcessResult.forEach(loginProcess => {
                loginProcess.userIds.forEach(loginProcessUserId => {
                    if (loginProcessUserId == userId) {
                        verifySuccessUserIds.push(userId);
                    }
                });
            });
        });
        if (verifySuccessUserIds.length != 1) {
            window.vue.$message({
                showClose: true,
                message: window.vue.$t('message.LOGIN_USER_ATYPISM'),
                type: 'warning'
            });
            callbackInfo.ret = false;
            return callback(callbackInfo);
        }
        let loginInfo = {
            userId: verifySuccessUserIds[0]
        };
        this.callbackLoginInfo(loginInfo);
        callbackInfo.ret = true;
        return callback(callbackInfo);
    },
    /* 回调登陆认证插件返回登陆成功的用户信息 */
    callbackLoginInfo(loginInfo) {
        for (const loginProcess of mustVerifyLoginProcessList) {
            let loginMethod = window.validateLogon.loginMethod.get(loginProcess.sCheckType);
            loginMethod['loginSucess'](loginInfo);
        }
        for (const loginProcess of verifyOneLoginProcessList) {
            let loginMethod = window.validateLogon.loginMethod.get(loginProcess.sCheckType);
            loginMethod['loginSucess'](loginInfo);
        }
    },
    /* 多种登录方式 */
    /**
     *
     * @param {*} loginType 登录方式
     * @param {*} callback 回调方法
     */
    validateLogon(loginInfo, processInfo, callback) {
        if (window.vue.$util.isEmpty(sessionStorage.getItem('systemId'))) {
            this.getSystemInfo(loginInfo, processInfo, callback);
        } else {
            this.starValidateLogon(loginInfo, processInfo, callback);
        }
    },
    starValidateLogon(loginInfo, processInfo, callback) {
        let currentProcessInfo = processInfo;
        if (window.vue.$util.isEmpty(processInfo)) {
            callbackInfo.ret = false;
            callbackInfo.message = 'common.LOGIN_PROCESS_ISNULL';
            return callback(callbackInfo);
        }
        let _this = this;
        let loginMethod = window.validateLogon.loginMethod.get(currentProcessInfo.sCheckType);
        if (loginMethod === undefined) {
            callbackInfo.message = 'common.LOGIN_PROCESS_ISNULL';
            callbackInfo.ret = false;
            return callback(callbackInfo);
        }
        loginMethod[currentProcessInfo.sUrl](loginInfo, function(val) {
            let result = window.vue.$util.clone(val, callback);
            if (!val.ret) {
                callbackInfo.message = val.message;
                callbackInfo.ret = false;
                return callback(callbackInfo);
            }
            if (currentProcessInfo.sCheckType == 'Password') {
                callbackInfo.ret = true;
                return callback(callbackInfo);
            }
            _this.loginByIdCode(currentProcessInfo.sCheckType, result, callback);
        });
    },
    /* 获取系统标识 */
    getSystemInfo(loginInfo, processInfo, callback) {
        let _this = this;
        window.vue.$api.getSystemInfo({}, response => {
            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('javaCommon.' + response.data.statusCode),
                    type: 'error'
                });
                window.vue.$log.error('menuManagement/deleteMenuInfo', response.data.statusMessage);
                callbackInfo.ret = false;
                return;
            }
            sessionStorage.setItem('systemId', response.data.content.systemId);
            _this.starValidateLogon(loginInfo, processInfo, callback);
        });
    },
    /**
     *  获取token
     * @param {*} info
     * @param callback 登录回调
     */
    loginByIdCode(type, info, callback) {
        if (type == 'userPasswordLogin') {
            return;
        }
        let param = {
            attrCode: [info.attrCode],
            loginType: [type],
            userId: info.userIds[0],
            sysId: sessionStorage.getItem('systemId')
        };
        window.vue.$api.loginByIdCode(param, response => {
            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$message({
                    showClose: true,
                    message: window.vue.$t('javaCommon.' + response.data.statusCode),
                    type: 'error'
                });
                window.vue.$log.error('loginByIdCode', response.data.statusMessage);
                callbackInfo.ret = false;
                callbackInfo.message = this.$t('javaCommon.' + response.data.statusCode);
                return callback(callbackInfo);
            }
            sessionStorage.setItem('token', response.data.content.token.replace(/[\n]/g, '').replace(/[\r]/g, ''));
            sessionStorage.setItem('username', response.data.content.userName);
            sessionStorage.setItem('userLevel', response.data.content.level);
            sessionStorage.setItem('userId', response.data.content.id);
            sessionStorage.setItem('ip', response.data.content.ip);
            /* 重新登录移除原有数据 */
            sessionStorage.removeItem(window.app.sPlatformFlg + 'curentTopMenuId');
            sessionStorage.removeItem(window.app.sPlatformFlg + 'leftMenuIndexId');
            callbackInfo.message = this.$t('javaCommon.' + response.data.statusCode);
            callbackInfo.ret = true;
            return callback(callbackInfo);
        });
    }
};
